import React from "react";

interface FilterPopupProps {
  filters: any;
  setFilters: (f: any) => void;
  onClose: () => void;
}

const FilterPopup: React.FC<FilterPopupProps> = ({ filters, setFilters, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-80">
        <h2 className="text-lg font-semibold mb-4">Filter Employees</h2>

        <div className="space-y-3">
          <select
            value={filters.department}
            onChange={(e) => setFilters({ ...filters, department: e.target.value })}
            className="border w-full p-2 rounded"
          >
            <option value="">All Departments</option>
            <option value="Sales">Sales</option>
            <option value="HR">HR</option>
            <option value="Engineering">Engineering</option>
          </select>

          <select
            value={filters.location}
            onChange={(e) => setFilters({ ...filters, location: e.target.value })}
            className="border w-full p-2 rounded"
          >
            <option value="">All Locations</option>
            <option value="Bangalore">Bangalore</option>
            <option value="Hyderabad">Hyderabad</option>
            <option value="Indore">Indore</option>
          </select>
        </div>

        <div className="mt-5 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 border rounded">
            Cancel
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-darkgreen text-white rounded"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterPopup;
